import React from 'react';

import { Anchor, Text, Spacer } from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

const FraudFailure = () => {
    const email = 'account_verification@zillow.com';

    return (
        <Spacer marginBottom="sm">
            <Center>
                <Text fontType="h6" as="div">We can not publish your listing at this time.</Text>
                <Text as="div">
                    Please contact&nbsp;
                    <Anchor href={`mailto:${email}`} escape={true}>{email}</Anchor>
                    &nbsp;to resolve the issue.
                </Text>
            </Center>
        </Spacer>
    );
};

export default FraudFailure;
